'use strict';

var _slicedToArray = require("/tmp/build_a9c3e3e2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _createForOfIteratorHelper = require("/tmp/build_a9c3e3e2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");
var _toConsumableArray = require("/tmp/build_a9c3e3e2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var stringWidth = require('string-width');
var stripAnsi = require('strip-ansi');
var ansiStyles = require('ansi-styles');
var ESCAPES = new Set(["\x1B", "\x9B"]);
var END_CODE = 39;
var wrapAnsi = function wrapAnsi(code) {
  return "".concat(ESCAPES.values().next().value, "[").concat(code, "m");
};

// Calculate the length of words split on ' ', ignoring
// the extra characters added by ansi escape codes
var wordLengths = function wordLengths(string) {
  return string.split(' ').map(function (character) {
    return stringWidth(character);
  });
};

// Wrap a long word across multiple rows
// Ansi escape codes do not count towards length
var wrapWord = function wrapWord(rows, word, columns) {
  var characters = _toConsumableArray(word);
  var insideEscape = false;
  var visible = stringWidth(stripAnsi(rows[rows.length - 1]));
  var _iterator = _createForOfIteratorHelper(characters.entries()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        index = _step$value[0],
        character = _step$value[1];
      var characterLength = stringWidth(character);
      if (visible + characterLength <= columns) {
        rows[rows.length - 1] += character;
      } else {
        rows.push(character);
        visible = 0;
      }
      if (ESCAPES.has(character)) {
        insideEscape = true;
      } else if (insideEscape && character === 'm') {
        insideEscape = false;
        continue;
      }
      if (insideEscape) {
        continue;
      }
      visible += characterLength;
      if (visible === columns && index < characters.length - 1) {
        rows.push('');
        visible = 0;
      }
    }

    // It's possible that the last row we copy over is only
    // ansi escape characters, handle this edge-case
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (!visible && rows[rows.length - 1].length > 0 && rows.length > 1) {
    rows[rows.length - 2] += rows.pop();
  }
};

// Trims spaces from a string ignoring invisible sequences
var stringVisibleTrimSpacesRight = function stringVisibleTrimSpacesRight(str) {
  var words = str.split(' ');
  var last = words.length;
  while (last > 0) {
    if (stringWidth(words[last - 1]) > 0) {
      break;
    }
    last--;
  }
  if (last === words.length) {
    return str;
  }
  return words.slice(0, last).join(' ') + words.slice(last).join('');
};

// The wrap-ansi module can be invoked
// in either 'hard' or 'soft' wrap mode
//
// 'hard' will never allow a string to take up more
// than columns characters
//
// 'soft' allows long words to expand past the column length
var exec = function exec(string, columns) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (options.trim !== false && string.trim() === '') {
    return '';
  }
  var pre = '';
  var ret = '';
  var escapeCode;
  var lengths = wordLengths(string);
  var rows = [''];
  var _iterator2 = _createForOfIteratorHelper(string.split(' ').entries()),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 2),
        index = _step2$value[0],
        word = _step2$value[1];
      if (options.trim !== false) {
        rows[rows.length - 1] = rows[rows.length - 1].trimLeft();
      }
      var rowLength = stringWidth(rows[rows.length - 1]);
      if (index !== 0) {
        if (rowLength >= columns && (options.wordWrap === false || options.trim === false)) {
          // If we start with a new word but the current row length equals the length of the columns, add a new row
          rows.push('');
          rowLength = 0;
        }
        if (rowLength > 0 || options.trim === false) {
          rows[rows.length - 1] += ' ';
          rowLength++;
        }
      }

      // In 'hard' wrap mode, the length of a line is
      // never allowed to extend past 'columns'
      if (options.hard && lengths[index] > columns) {
        var remainingColumns = columns - rowLength;
        var breaksStartingThisLine = 1 + Math.floor((lengths[index] - remainingColumns - 1) / columns);
        var breaksStartingNextLine = Math.floor((lengths[index] - 1) / columns);
        if (breaksStartingNextLine < breaksStartingThisLine) {
          rows.push('');
        }
        wrapWord(rows, word, columns);
        continue;
      }
      if (rowLength + lengths[index] > columns && rowLength > 0 && lengths[index] > 0) {
        if (options.wordWrap === false && rowLength < columns) {
          wrapWord(rows, word, columns);
          continue;
        }
        rows.push('');
      }
      if (rowLength + lengths[index] > columns && options.wordWrap === false) {
        wrapWord(rows, word, columns);
        continue;
      }
      rows[rows.length - 1] += word;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  if (options.trim !== false) {
    rows = rows.map(stringVisibleTrimSpacesRight);
  }
  pre = rows.join('\n');
  var _iterator3 = _createForOfIteratorHelper(_toConsumableArray(pre).entries()),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _slicedToArray(_step3.value, 2),
        _index = _step3$value[0],
        character = _step3$value[1];
      ret += character;
      if (ESCAPES.has(character)) {
        var _code = parseFloat(/\d[^m]*/.exec(pre.slice(_index, _index + 4)));
        escapeCode = _code === END_CODE ? null : _code;
      }
      var code = ansiStyles.codes.get(Number(escapeCode));
      if (escapeCode && code) {
        if (pre[_index + 1] === '\n') {
          ret += wrapAnsi(code);
        } else if (character === '\n') {
          ret += wrapAnsi(escapeCode);
        }
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return ret;
};

// For each newline, invoke the method separately
module.exports = function (string, columns, options) {
  return String(string).normalize().split('\n').map(function (line) {
    return exec(line, columns, options);
  }).join('\n');
};